import { useApi } from '@/api';
import { Page, PageSkeleton, TextSearchFilter } from '@/components';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
import TokenHoldersTable from './TokenHoldersTable';

export default function TokenHoldersArbitrumPage() {
  const { address } = useParams();

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-balance',
    filtersDebounceTime: 250,
    initialFilters: {
      textSearch: ''
    }
  });

  const [data, error] = useApi({
    url: `/tokens/arbitrum/${address}/`
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Heading size="1">
            <Flex
              flexBasis="100%"
              gap={['xs', '2xs']}
              flexDirection={['column', 'row']}>
              <CryptoIcon
                name={data.symbol}
                address={address}
                network="arbitrum"
                size="3"
              />
              {data.symbol} Holders
            </Flex>
          </Heading>
        }>
        <HistoricTabs address={address} />
        <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
          <TextSearchFilter filters={filters} placeholder="Search by wallet" />
        </Flex>
        <TokenHoldersTable
          address={address}
          pagination={pagination}
          sorting={sorting}
          search={filters.filtersApplied['textSearch']}
        />
      </Page>
    );
  }

  return <PageSkeleton />;
}
